module.exports = __webpack_public_path__ + "img/manage-orders.4ca22c01.svg";